import dayjs from "dayjs";
import weekday from 'dayjs/plugin/weekday'
import updateLocale from 'dayjs/plugin/updateLocale'
import de from 'dayjs/locale/de';
import fr from 'dayjs/locale/fr';
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(weekday)
dayjs.extend(updateLocale)
dayjs.extend(customParseFormat)

dayjs.locale({
	...de, ...fr,
	weekStart: 1,
});

window['dayjs'] = dayjs

export default dayjs

export const getWeekDay = (weekDay) => {
	return dayjs().weekday(weekDay).format("dd")
}

export const formatDate = (date, format = "YYYY-MM-DD") => {
	return dayjs(date).format(format)
}

export const formatDateDE = (date, format = "DD.MM.YYYY") => {
	if(!date){
		return ""
	}
	return dayjs(date).format(format)
}

export const formatDateTimeDE = (date, format = "DD.MM.YYYY HH:mm") => {
	if(!date){
		return ""
	}
	return dayjs(date).format(format)
}

export const formatDateFromXToDE = (date, fromFormat: string | string[] = "YYYY-MM-DD HH:mm", format = "DD.MM.YYYY") => {
	if(!date){
		return ""
	}
	return dayjs(date, fromFormat).format(format)
}

export const unixToDate = (ts: number) => {
	return dayjs.unix(ts)
}

export const commonFormats = ['DD.MM.YYYY', 'YYYY-MM-DD', 'D.MM.YYYY', 'DD.M.YYYY', 'DD.MM.YY', 'D.M.YY'];
// export const commonFormats = ['DD.MM.YYYY', 'D.MM.YYYY', 'DD.M.YYYY', 'DD.MM.YY', 'D.M.YY', 'D.M.YYYY', 'YYYY-MM-DD'];